import { z } from "zod";
export const idParamSchema = z.object({ id: z.string().uuid() });
export const shortQrCodeSchema = z.string()
    .min(1)
    .max(8)
    .regex(/^[a-zA-Z0-9-]+$/);
export const placeIdInputSchema = z.literal("").or(z.string().trim()
    .min(5)
    .max(255)
    .regex(/^[A-Za-z0-9_-]+$/));
export const qrRouteInputSchema = z.object({
    hotelId: z.string().uuid(),
    locationId: z.string().uuid(),
    subLocationId: z.string().uuid().optional(),
    hotelCode: shortQrCodeSchema.max(5),
    locationCode: shortQrCodeSchema.max(5),
    unitCode: shortQrCodeSchema.optional(),
    label: z.string().min(1).max(200),
    status: z.enum(["active", "paused", "archived"]).default("active"),
    campaignTags: z.record(z.unknown()).default({})
});
export const subLocationInputSchema = z.object({
    hotelId: z.string().uuid(),
    locationId: z.string().uuid(),
    name: z.string().min(1).max(200),
    code: shortQrCodeSchema,
    type: z.string().min(1).max(80).default("unit"),
    googleReviewUrl: z.string().url().max(500).optional().or(z.literal("")),
    placeId: placeIdInputSchema.optional(),
    status: z.enum(["active", "paused", "archived"]).default("active")
});
export const surveyRuleInputSchema = z.object({
    surveyId: z.string().uuid(),
    name: z.string().min(1).max(200),
    priority: z.number().int().min(0).max(10000),
    hotelId: z.string().uuid().optional(),
    locationTypeId: z.string().uuid().optional(),
    locationId: z.string().uuid().optional(),
    mealPeriod: z.string().max(40).optional(),
    activeFrom: z.string().datetime().optional(),
    activeTo: z.string().datetime().optional(),
    daysOfWeek: z.array(z.number().int().min(0).max(6)).optional(),
    timeWindows: z.array(z.object({ start: z.string(), end: z.string() })).optional(),
    conditions: z.record(z.unknown()).default({}),
    status: z.enum(["active", "paused", "archived"]).default("active")
});
